module.exports = __webpack_public_path__ + "static/media/form.bcd63d0d.png";